import React, { useState } from 'react';
import PickAndPackContext from './PickAndContext';
import { getCurrenciesDenominationsByCustomer } from '../../../networking/NetworkingCurrencies';
import { getBankNoteOrder } from '../../../networking/NetworkingBankNotes';
import useLookUpTables from '../../maintenance/complaints/useLookUpTables';
import { useEffect } from 'react';
import { getRolesByUsername } from '../../../networking/NetworkingRoles';

const BANKNOTES_ADMIN = 'BankNotesAdmin'

const PickAndPackProvider = ({ children }) => {

    const [bankNoteOrder, setBankNoteOrder] = useState({});
    const [customerDenominations, setCustomerDenominations] = useState([]);
    const [lockedSide, setLockedSide] = useState('');
    const [sellDeliveryStatusOptions, setSellDeliveryStatusOptions] = useState([]);    
    const [buyDeliveryStatusOptions, setBuyDeliveryStatusOptions] = useState([]);
    const [isBankNotesAdmin, setIsBankNotesAdmin] = useState(false)  

    const lookUpTables = useLookUpTables('BN Delivery Buy Status,BN Delivery Sell Status');

  useEffect(() => {
    const loadRoles = async () => {
      getRolesByUsername('ForeignExchange', localStorage.getItem('UserName')).then(
        (response) => {
          console.log('loadRoles ', response)
          if (response && Array.isArray(response) && response.map(e => e.toLowerCase()).includes(BANKNOTES_ADMIN.toLowerCase())) {
            setIsBankNotesAdmin(true)
          }
          else {
            setIsBankNotesAdmin(false)
          }
        }
      )
    }

    loadRoles();
  }, [])

    const getBankOrder = async (orderId) => {
        const order = await getBankNoteOrder(orderId)
        console.log('order ', order)
        if (order && order.CustomerId > 0) {

            setBankNoteOrder(order)
            const currenciesResponse = await getCurrenciesDenominationsByCustomer(order.CustomerId)
            console.log('currenciesResponse ', currenciesResponse)

            if (currenciesResponse && currenciesResponse.currencies) {
                setCustomerDenominations(currenciesResponse.currencies);
            }
        }
        else {
            setBankNoteOrder({});
            setCustomerDenominations([]);
        }
    }

    return (
      <PickAndPackContext.Provider
        value={{
          lockedSide,
          setLockedSide,
          bankNoteOrder,
          setBankNoteOrder,
          getBankOrder,
          customerDenominations,
          lookUpTables,
          sellDeliveryStatusOptions,
          setSellDeliveryStatusOptions,
          buyDeliveryStatusOptions,
          setBuyDeliveryStatusOptions,
          isBankNotesAdmin
        }}
      >
        {children}
      </PickAndPackContext.Provider>
    );
};

export default PickAndPackProvider;